<h2 mat-dialog-title>
    {{ !data.hasId() ? "Konsument erstellen" : "Konsument bearbeiten" }}
</h2>

<mat-divider></mat-divider>
<mat-dialog-content>
    <mat-tab-group id="tab-group">
        <form [formGroup]="consumerForm">
            <mat-tab label="Bearbeiten">
                <br />
                <div>
                    <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name" />
                        @if (consumerForm.get("name")?.hasError("required")) {
                            <mat-error>Name ist erforderlich</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>URL</mat-label>
                        <input matInput formControlName="url" placeholder="https://www.westermanngruppe.de" />
                        @if (consumerForm.get("url")?.hasError("pattern")) {
                            <mat-error>URL ungültig</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>Beschreibung</mat-label>
                        <input matInput formControlName="description" />
                        @if (consumerForm.get("description")?.hasError("required")) {
                            <mat-error>Beschreibung erforderlich</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>Authentifizierung</mat-label>
                        <mat-select formControlName="authorization">
                            <mat-option value="NoAuthorization">Keine Authentifizierung</mat-option>
                            <mat-option value="BasicAuth">BasicAuth</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </mat-tab>

            <mat-tab label="Playerfunktionalität">
                <div formGroupName="playerSettings">
                    <mat-tab-group>
                        <mat-tab label="Funktionen">
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="selfJudgementPopup"> Selbsteinschätzung </mat-checkbox>
                                </div>
                                <div class="player-description">
                                    Nach dem Lösen einer Einzelaufgabe / Sequenz wird das Popup zur Selbsteinschätzung angezeigt. Hier kann der/die Schüler/in
                                    die Lerneinheit bewerten.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="dontKnowBtn"> <i>Weiß ich nicht</i>-Button </mat-checkbox>
                                </div>
                                <div class="player-description">An jeder Aufgabe wird der 'Weiß ich nicht' Button angezeigt.</div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="readoutExerciseText"> Aufgabentext / Arbeitsanweisung </mat-checkbox>
                                </div>
                                <div class="player-description">
                                    An jeder Aufgabe wird ein Button zum Abspielen des Aufgabentextes angezeigt, wenn Audiodateien an der Aufgabe gepflegt
                                    wurden. Die Pflege ist verfügbar, wenn der Konsument das entsprechendes Metadatum hat. Andernfalls ist diese Option nicht
                                    verfügbar.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="randomOrderOfTestSequences">
                                        Zufällige Anordnung von Testsequenzen in einem Test
                                    </mat-checkbox>
                                </div>
                                <div class="player-description">
                                    Die Sequenzen in einem Test werden in zufälliger Reihenfolge ausgespielt. Die Reihenfolge der einzelnen Aufgaben innerhalb
                                    einer Testsequenz bleibt aber erhalten.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="textSelectionEnabled">Auswahl von Text</mat-checkbox>
                                </div>
                                <div class="player-description">
                                    Das Auswählen von Text (u.a. zum Kopieren) wird normalerweise verhindert, kann aber hier angeschaltet werden.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="emptyAnswerWarningPopup"> Sicherheitsabfrage bei leerer Eingabe </mat-checkbox>
                                </div>
                                <div class="player-description">Es wird eine Sicherheitsabfrage angezeigt, wenn eine Aufgabe ohne Eingabe beendet wird.</div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="checkAnswerPopup"> Aufforderung Lösungsüberprüfung </mat-checkbox>
                                </div>
                                <div class="player-description">
                                    An jedem Test kann gepflegt werden, ob dem Nutzer beim Beenden einer jeden Aufgabe der Hinweis(Popup) zur Lösungskontrolle
                                    angezeigt wird (default=aktiv). Dies kann hier global aktiviert/deaktiviert werden.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="showNoteButton"> Notizfunktion </mat-checkbox>
                                </div>
                                <div class="player-description">
                                    Lehrer und ein Schüler können an jeder Übungsaufgabe eine Notiz hinterlegen und ihre Notizen untereinander einsehen.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="showBottomPart"> Unterer Aufgabenteil</mat-checkbox>
                                </div>
                                <div class="player-description">
                                    Redakteure können in Übungs- und Testaufgaben einen weiteren Text-Baustein pflegen. Dieser wird aktuell für die Anzeige
                                    einer Musterlösung verwendet, welche Nutzer über einen Button "Musterlösung" einsehen können. Der Button wird unterhalb des
                                    zweiten Aufgabenteils angezeigt.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="showExerciseSequenceTabs"> Tabs zur Aufgabennavigation </mat-checkbox>
                                </div>
                                <div class="player-description">Nutzer können innerhalb einer Übungssequenz über Tabs navigieren.</div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="showSelfRating"> Selbstbewertung </mat-checkbox>
                                </div>
                                <div class="player-description">
                                    Nutzer können Ihre Lösung mit der Musterlösung abgleichen und sich selber bewerten. Dieses Feature wird aktuell im
                                    Prüfungsportal verwendet.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="hideResetExerciseButton"> Button "Zurücksetzen" ausblessenden </mat-checkbox>
                                </div>
                                <div class="player-description">Nutzer können Ihre Lösung nicht mehr für einzelne Aufgaben zurücksetzen.</div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="showCompletionIcons"> Lösungsfortschritt der Übungsaufgaben anzeigen </mat-checkbox>
                                </div>
                                <div class="player-description">
                                    An den Reitern einer Übungssequenz werden Icons für die Zustände "richtig", "falsch" und "übersprungen" angezeigt.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="tabLetters"> Reiter alphabetisch beschriften </mat-checkbox>
                                </div>
                                <div class="player-description">Die Reiter einer Übungssequenz sind mit Buchstaben beschriftet.</div>
                            </div>
                            <div class="player-setting">
                                <div>
                                    <mat-checkbox formControlName="flattenExercises">
                                        Zusammenhängende Übungsaufgaben auf einzelne Reiter aufteilen.
                                    </mat-checkbox>
                                </div>
                                <div class="player-description">
                                    Jede Übungsaufgabe erhält ihren eigenen Reiter. Hinweis: Dieses Feature wird im Prüfungsportal aktuell nicht unterstützt!
                                </div>
                            </div>
                            <div class="player-setting">
                                <div class="player-setting-combo">
                                    <mat-form-field>
                                        <mat-label>Anzahl Versuche</mat-label>
                                        <mat-select formControlName="maxTries">
                                            <mat-option value="1">1</mat-option>
                                            <mat-option value="2">2</mat-option>
                                            <mat-option value="3">3</mat-option>
                                            <mat-option value="4">4</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="player-description">
                                    Die Zahl gibt an, nach wievielen Bearbeitungsversuchen einer Übungsaufgabe der "Lösungsvergleich" im Player verfügbar ist.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div class="player-setting-combo">
                                    <mat-form-field>
                                        <mat-label>Nochmal versuchen</mat-label>
                                        <mat-select formControlName="retryMode">
                                            <mat-option value="keepCorrectAnswers">Korrekte Antworten behalten</mat-option>
                                            <mat-option value="freezeCorrectAnswers">Korrekte Antworten einfrieren</mat-option>
                                            <mat-option value="clearAllAnswers">Alle Antworten zurücksetzen</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="player-description">
                                    Verhalten der Antworten nach Klick auf "Nochmal versuchen".<br />
                                    <b>Korrekte Antworten behalten</b>: Korrekte Antwoten bleiben erhalten und lassen sich ändern. Korrekt-Markierungen (grüne
                                    Rahmen und ggf. grüne Haken) werden ausgeblendet.<br />
                                    <b>Korrekte Antworten einfrieren</b>: Korrekte Antworten bleiben erhalten und lassen sich nicht ändern. Korrekt-Markierungen
                                    (grüne Rahmen und ggf. grüne Haken) bleiben erhalten.
                                </div>
                            </div>
                            <div class="player-setting">
                                <div class="player-setting-combo">
                                    <mat-form-field>
                                        <mat-label>Footer-Info</mat-label>
                                        <mat-select formControlName="footerInfo">
                                            <mat-option value="none">Keine Anzeige</mat-option>
                                            <mat-option value="id">Aufgaben-ID</mat-option>
                                            <mat-option value="name">Aufgaben-Name</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="player-description">
                                    Mitarbeiter der Kundenberatung können die Aufgaben-ID/den Aufgaben-Namen beim Kunden abfragen oder auf Screenshots sehen,
                                    damit eine detaillierte Fehlermeldung erstellt werden kann.<br />
                                    <b>Aufgaben-ID</b>: Im Footer wird die ID der aktuellen Aufgabe anzeigt.<br />
                                    <b>Aufgaben-Name</b>: Im Footer wird der Name der aktuellen Aufgabe angezeigt
                                </div>
                            </div>
                        </mat-tab>

                        <mat-tab label="Farbschema">
                            <br />
                            <div class="player-colors-container" formGroupName="theme">
                                <div class="player-colors-item">Primärfarbe</div>
                                <div class="player-colors-item">
                                    <ngx-colors
                                        ngx-colors-trigger
                                        [format]="'hex'"
                                        formControlName="primaryColor"
                                        acceptLabel="Übernehmen"
                                        cancelLabel="Abbrechen"
                                        (close)="sendThemeToPlayer()"
                                    ></ngx-colors>
                                </div>
                                <div class="player-colors-preview">
                                    @if (!data.hasId()) {
                                        Eine Vorschau im Player ist bei einem neuen Konsumenten nicht möglich, da noch keine Konsumenten-ID vorhanden ist.
                                        <br /><br />
                                        Dieser neue Konsument muss zunächst gespeichert werden, um eine Konsumenten-ID zu erhalten, die dann im Player für die
                                        Vorschau verwendet werden kann.
                                    } @else {
                                        <div class="btn-iframe">
                                            <button
                                                mat-button
                                                (click)="setDefaultTheme()"
                                                [disabled]="disabledColorSchemeBtn()"
                                                matTooltip="Farbschema auf das Eingangsfarbschema zurücksetzen"
                                            >
                                                Farbschema zurücksetzen
                                            </button>
                                        </div>
                                        <iframe
                                            #playerPreviewIframe
                                            class="consumerPlayerSettingsPreview"
                                            [src]="iframePreviewUrl!"
                                            (load)="onIframeLoaded()"
                                        ></iframe>
                                    }
                                </div>

                                <div class="player-colors-item">Sekundärfarbe</div>
                                <div class="player-colors-item">
                                    <ngx-colors
                                        ngx-colors-trigger
                                        [format]="'hex'"
                                        formControlName="secondaryColor"
                                        acceptLabel="Übernehmen"
                                        cancelLabel="Abbrechen"
                                        (close)="sendThemeToPlayer()"
                                    ></ngx-colors>
                                </div>

                                <div class="player-colors-item">Tertiärfarbe</div>
                                <div class="player-colors-item">
                                    <ngx-colors
                                        ngx-colors-trigger
                                        [format]="'hex'"
                                        formControlName="tertiaryColor"
                                        acceptLabel="Übernehmen"
                                        cancelLabel="Abbrechen"
                                        (close)="sendThemeToPlayer()"
                                    ></ngx-colors>
                                </div>

                                <div class="player-colors-item">Platzhalter-Farbe</div>
                                <div class="player-colors-item">
                                    <ngx-colors
                                        ngx-colors-trigger
                                        [format]="'hex'"
                                        formControlName="placeholderColor"
                                        acceptLabel="Übernehmen"
                                        cancelLabel="Abbrechen"
                                        (close)="sendThemeToPlayer()"
                                    ></ngx-colors>
                                </div>

                                <div class="player-colors-item">Mouseover-Farbe</div>
                                <div class="player-colors-item">
                                    <ngx-colors
                                        ngx-colors-trigger
                                        [format]="'hex'"
                                        formControlName="hoverColor"
                                        acceptLabel="Übernehmen"
                                        cancelLabel="Abbrechen"
                                        (close)="sendThemeToPlayer()"
                                    ></ngx-colors>
                                </div>

                                <div class="player-colors-item">Zeichenstift-Farbe</div>
                                <div class="player-colors-item">
                                    <ngx-colors
                                        ngx-colors-trigger
                                        [format]="'hex'"
                                        formControlName="drawColor"
                                        acceptLabel="Übernehmen"
                                        cancelLabel="Abbrechen"
                                        (close)="sendThemeToPlayer()"
                                    ></ngx-colors>
                                </div>

                                <div class="player-colors-item">Zeichnungs-Selektions-Farbe</div>
                                <div class="player-colors-item">
                                    <ngx-colors
                                        class="ngx-color"
                                        ngx-colors-trigger
                                        [format]="'hex'"
                                        formControlName="drawHighlightColor"
                                        acceptLabel="Übernehmen"
                                        cancelLabel="Abbrechen"
                                        (close)="sendThemeToPlayer()"
                                    ></ngx-colors>
                                </div>

                                <div class="player-colors-item">Lösungsvergleich Hintergrundfarbe</div>
                                <div class="player-colors-item">
                                    <ngx-colors
                                        ngx-colors-trigger
                                        [format]="'hex'"
                                        formControlName="compareSolutionsBgColor"
                                        acceptLabel="Übernehmen"
                                        cancelLabel="Abbrechen"
                                        (close)="sendThemeToPlayer()"
                                    ></ngx-colors>
                                </div>
                            </div>
                        </mat-tab>

                        <mat-tab label="Schriftart">
                            <br />
                            <div class="player-fonts-section">
                                @for (group of groupedCompetencies; track group.letter) {
                                    <div class="player-letter-group">
                                        <h3>{{ group.letter }}</h3>
                                        <div class="player-fonts-container">
                                            @for (competency of group.competencies; track competency.treeId) {
                                                <div class="player-font-item">
                                                    <mat-form-field>
                                                        <mat-label>{{ competency.name }}</mat-label>
                                                        <mat-select [value]="getFont(competency)" (valueChange)="setFont($event, competency)">
                                                            @for (font of availableFonts; track font.id) {
                                                                <mat-option [value]="font.id">{{ font.name }}</mat-option>
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </mat-tab>
        </form>
    </mat-tab-group>
</mat-dialog-content>

<mat-divider></mat-divider>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!consumerForm.valid">Speichern</button>
</div>
